import { StepsActions } from "../../reducers/steps/actionsNames";

export default function () {
  return {
    type: StepsActions.Reset,
  };
}
